import {environment} from '../../../environments/environment';

/**
 * The path of a file in this app's own storage bucket, from its download URL
 * (https://firebasestorage.googleapis.com/v0/b/<bucket>/o/<path>?...); null
 * for any other URL.
 *
 * A layer's file is downloaded by everyone who opens its project, embeds
 * included, and anyone who may draw there can write the layer's document. A
 * URL on another host would have every viewer fetch it, telling that host
 * their address, and a huge file from it froze their tab on every visit. So
 * only files the app stored itself are opened. Same rule as the .mmp import
 * (MmpLoader.ownStoragePath), which drops other hosts' layers.
 */
export function ownStoragePath(url: string): string | null {
  const bucket = environment.firebase.storageBucket;
  const prefix = `/v0/b/${bucket}/o/`;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch (e) {
    return null;
  }
  if (!bucket || parsed.protocol !== 'https:' || parsed.hostname !== 'firebasestorage.googleapis.com'
    || !parsed.pathname.startsWith(prefix)) {
    return null;
  }
  try {
    return decodeURIComponent(parsed.pathname.substring(prefix.length));
  } catch (e) {
    return null;
  }
}

/** Whether a URL is a file in this app's own storage bucket (see ownStoragePath). */
export function isOwnStorageUrl(url: string): boolean {
  return ownStoragePath(url) !== null;
}
